<template>
    <v-card width="100%" flat>
        <v-card-title>
            <div class="headline">
                Kontrolní místa
            </div>
            <v-spacer></v-spacer>

            <v-combobox
                    clearable
                    single-line
                    hide-details
                    class="pt-0"
                    label="Filtrovat podle uživatele"
                    :items="users"
                    item-value="id"
                    item-text="name"
                    v-model="selectedUser"
                    v-if="$store.state.user.logged.isSuperuser"
            ></v-combobox>

            <v-spacer></v-spacer>

            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Vyhledávání"
                    single-line
                    class="pt-0"
                    hide-details
            ></v-text-field>

            <v-spacer></v-spacer>

            <v-btn fab dark small color="success" @click="addItem">
                <v-icon dark>add</v-icon>
            </v-btn>
        </v-card-title>

        <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredCheckpoints"
                :search="search"
                :loading="$store.state.loading"
                dense
                class="checkpoints-data-table"
        >
            <template v-slot:item.user.name="{ item }">
                {{ item.user.username }}
            </template>
            <template v-slot:item.ticketsetCount="{ item }">
                {{ item.ticketsets.length }}
            </template>
            <template v-slot:item.action="{ item }">
                <EditDeleteActions
                        @delete="deleteItem(item.id)"
                        @edit="editItem(item)"
                />
            </template>
        </v-data-table>

        <CheckpointDialog ref="dialog" @complete="onComplete" />

        <DeleteConfirm :show="deleteConfirm"
                       @confirm="doDeleteConfirm"
                       @cancel="deleteConfirm=false"
        />
    </v-card>
</template>

<script>
    import BaseListMixin from '../mixins/BaseListMixin'
    import CheckpointDialog from '../components/dialogs/CheckpointDialog'

    export default {
        mixins: [BaseListMixin],

        components: {
            CheckpointDialog
        },

        data () {
            return {
                module: 'checkpoint',
                headers: [
                    { text: 'Jméno', value: 'name' },
                    { text: 'Uživatel', value: 'user.name' },
                    { text: 'Sad vstupenek', value: 'ticketsetCount' },
                    { text: '', value: 'action', sortable: false, width:'1px' }
                ],
                selectedUser: null
            }
        },

        computed: {
            users () {
                return this.$store.state.user.list.map(user => {
                    return {
                        id: user.id,
                        name: `${user.firstName} ${user.lastName}`
                    }
                })
            },
            filteredCheckpoints () {
                if (this.selectedUser) {
                    return this.items.filter(checkpoint => checkpoint.user.id === this.selectedUser.id)
                }
                return this.items
            }
        },

        created() {
            this.$store.dispatch('user/list')
            this.$store.dispatch('ticketset/list')
        }
    }
</script>

<style lang="scss">
    .checkpoints-data-table {
        thead th:first-child {
            width: 50%;
        }
    }
</style>
